/**
 * Handle hamburger issues
 * @module handleHamburgers
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'hamburger';
export const DEFAULTS = {
  switchClass: '',
  switchTarget: '',
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  const $pageContent = $('#page-content');
  const $footerContent = $('#site-footer');
  let $changingElClass = $($el.attr('href'));
  // If a data-switch-target attribute was used instead of href
  if (options.switchTarget !== '') {
    $changingElClass = $(options.switchTarget);
  }
  $el.on('click', (evt) => {
    evt.preventDefault();
    const pageScrollPos = window.scrollY;
    if ($changingElClass.hasClass(options.switchClass)) {
      $changingElClass.removeClass(options.switchClass);
      $pageContent.css({ transform: '' });
      $footerContent.css({ transform: '' });
      window.scrollTo(0, $pageContent.data('scrollPos'));
      Keyboard.releaseFocus($('.nav-side'), $('#js-nav-side-btn'));
      $('#js-nav-side-btn').trigger('focus');
      $('#js-nav-side').on('transitionend webkitTransitionEnd oTransitionEnd', () => {
        $('#js-nav-side').off('transitionend webkitTransitionEnd oTransitionEnd');
        $('#js-nav-side').parent().attr('aria-modal', 'false');
        $('#js-nav-side').parent().hide();
      });
    } else {
      $('#js-nav-side').parent().show(() => {
        $changingElClass.addClass(options.switchClass);
        $pageContent.css({ transform: `translateY(-${pageScrollPos}px)` }).data('scrollPos', pageScrollPos);
        $footerContent.css({ transform: `translateY(-${pageScrollPos}px)` });
        Keyboard.trapFocus($('.nav-side'));
        $('#js-nav-side').parent().attr('aria-modal', 'true');
        $('#js-nav-side__close').trigger('focus');
      });
    }
  });
};
/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function hamburger(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, hamburger);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/hamburger.js